import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IPageParams, ICRUDResponse, ICompanyType } from '@/models';

export interface ICompanyTypeState {
  entities: Record<string, ICompanyType>;
  currentPage: number[];
  pageParams: Partial<IPageParams>;
}

export const companyType: Module<ICompanyTypeState, IRootState> = {
  namespaced: true,
  state: {
    entities: {},
    currentPage: [],
    pageParams: {
      per_page: 15,
    }
  },
  actions: {
    getEntities({ commit }) {
      client
        .get<ICRUDResponse<ICompanyType[]>>('company_type')
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', data);
          commit('setPageParams', pageParams);
        });
    },
    getEntity({ commit }, id) {
      client
        .get<ICRUDResponse<ICompanyType>>(`company_type/${id}`)
        .then(({ data }) => {
          commit('setEntities', data);
        });
    },
    createEntity({ dispatch }, entity: Omit<ICompanyType, 'id'>) {
      return client
        .post('company_type', entity)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
    deleteEntity({ dispatch }, entity: ICompanyType) {
      return client
        .delete(`company_type/${entity.id}`)
        .then(() => dispatch('getEntities'));
    },
    updateEntity({ dispatch }, entity: ICompanyType) {
      return client
        .put(`company_type/${entity.id}`, entity)
        .then(({ data }) => {
          dispatch('getEntities')
          return data
        });
    },
  },
  mutations: {
    setEntities(state, datum: ICompanyType | ICompanyType[]) {
      const entities = Array.isArray(datum) ? datum : [datum];
      state.entities = entities.reduce(
        (acc, item) => ({ ...acc, [item.id]: item }),
        {},
      );
      state.currentPage = entities.map((entity) => entity.id);
    },
    setPageParams(
      state,
      pageParams: Omit<ICRUDResponse<ICompanyType[]>, 'data'>,
    ) {
      state.pageParams = pageParams;
    },
  },
  getters: {
    entitiesSlice({ currentPage, entities }) {
      return currentPage.map((id) => entities[id]);
    },
  },
};
